import { GET_CITIES } from "../../Actions/ActionConstants";

function CitiesReducer(state=null,action){
    switch (action.type) {
        case GET_CITIES:
                if(action.data){return action.data;}
                else{return state}
        default:
            return state;
    }
}
export default CitiesReducer